module.exports = __webpack_public_path__ + "img/avatar48-2.486d9a57.png";